export default __webpack_public_path__ + "static/media/instagram_challenge.00d0eece.jpg";